var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('TopNav',{attrs:{"drawer":_vm.drawer}}),_c('SidebarNav',{attrs:{"drawer":_vm.drawer}}),_c('List',{attrs:{"products":_vm.products,"maximum":_vm.maximum,"cart":_vm.cart}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }